import React, { useContext } from 'react';
import { ApplicationUIContext } from '@yuhuinc/ui-library';

import { Card, Row, Button, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import styled, { css } from 'styled-components';

import ApplicationTodos from './ApplicationTodos';
import ApplicationMessages from './ApplicationMessages';
import ApplicationPayments from './ApplicationPayments';
import ApplicationInsurance from './ApplicationInsurance';
import ApplicationDocuments from './ApplicationDocuments';
import ApplicationPeople from './ApplicationPeople';
import { phaseTwoWip } from 'components/landlord_app/application_management/common/actions/WipModal';

const { Title } = Typography;

const StyledHelpButton = styled(Button)`
  ${(props) =>
    props.isMobile &&
    css`
      width: 100%;
    `}
`;

const ApplicationSummary = ({ cotenantId, cotenant }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <>
      <Card>
        <Row justify="space-between">
          <Title level={3} style={{ margin: 0 }}>
            Application for {cotenant.title}
          </Title>
          <StyledHelpButton
            type="default"
            size="medium"
            isMobile={isMobile}
            onClick={() => {
              phaseTwoWip(() => {});
            }}
          >
            <QuestionCircleOutlined /> Help
          </StyledHelpButton>
        </Row>
        <ApplicationTodos cotenantId={cotenantId} />
        <ApplicationPayments cotenant={cotenant} />
        <ApplicationMessages messages={cotenant?.team_messages} />
        <ApplicationInsurance cotenantId={cotenantId} />
        <ApplicationPeople application={cotenant?.application} />
        <ApplicationDocuments cotenantId={cotenantId} />
      </Card>
    </>
  );
};

export default ApplicationSummary;
